const LESSON_COUNT_UNIT_DELIMITER_KEY = 'cp.lessonCountUnitDelimiter.v1';

export function loadLessonCountUnitDelimiter(): string {
  if (typeof window === 'undefined') return '';
  try {
    return window.localStorage.getItem(LESSON_COUNT_UNIT_DELIMITER_KEY) ?? '';
  } catch {
    return '';
  }
}

export function saveLessonCountUnitDelimiter(delimiter: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LESSON_COUNT_UNIT_DELIMITER_KEY, delimiter);
  } catch {
    // ignore
  }
}
